import { Backdrop, Box, CircularProgress, Stack } from "@mui/material"

export const BackDrop = ({ open = false, text = "Loading" }) => {
    return (
        <Backdrop open={open} sx={{ zIndex: 1305, backgroundColor: "rgba(255,255,255,0.2)", backdropFilter: "blur(6px)" }}>
            <Box height="150px" width="100%" display="flex" alignItems="center" justifyContent="center">
                <Box height="100%" width="270px" borderRadius="12px" display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3} sx={{ bgcolor: "rgba(0,0,0,0.6)", color: "#fff" }}>
                <Stack sx={{ color: "grey.300" }} spacing={2} direction="row">
                    <CircularProgress color="inherit" />
                </Stack>
                <Box>{text}</Box>
                </Box>
            </Box>
        </Backdrop>
    );
};